<template>
	<div class="login_wrap" :style="theme === 'renshe' ? { minHeight: '820px' } : { minHeight: '820px' }">
		<!-- 模块化配置logo -->
		<div>
			<!-- 人社、且行业标签不是交通 -->
			<img v-if="theme === 'renshe' && branchIndustry !== 'traffic'" src="@/assets/images/rs_logo.png" alt="" class="logo" />
			<img v-else-if="theme !== 'honghui' && loginBackgroundLogo" :src="loginBackgroundLogo" alt="" class="login-top" />
		</div>
		<div class="login">
			<div class="bg_width"></div>
			<img :src="loginImg" alt="" class="login-left" />
			<div class="login-box" v-if="islogin">
				<div class="login-international" v-if="isI18nFlag" @mouseenter="setUpLanguageEnter()" @mouseleave="setUpLanguageLeave()">
					<!-- <img class="fl"  src="../../assets/images/china.png" alt="" />
					<img class="fl"  src="../../assets/images/english.png" alt="" /> -->
					<!-- <img class="fl" v-else-if="internationalKey == 'fr-FR'" src="../../assets/images/france.png" alt="" /> -->
					<span class="fl">
						{{ $t(internationalName) }}
					</span>
					<img src="../../assets/images/down.png" alt="" class="international-img" />
					<ul v-show="setUpLanguageShow" @mouseenter="setUpLanguageEnter()" @mouseleave="setUpLanguageLeave()">
						<li v-for="item in international" :key="item.key" @click="selectChange(item.key, item.val)">
							<!-- <img v-if="item.key == 'zh-CN'" src="../../assets/images/china.png" alt="">
							<img v-else-if="item.key == 'en-US' " src="../../assets/images/english.png" alt=""> -->
							<!-- <img v-else-if="item.key == 'fr-FR'" src="../../assets/images/france.png" alt=""> -->
							<span>{{ $t(item.val) }}</span>
						</li>
					</ul>
				</div>
				<ul class="tabs">
					<li
						:key="item.key"
						v-for="(item, index) in tabsList"
						@click="setActiveName(item.key)"
						:style="index === 0 ? 'margin-right:40px' : ''"
						:class="{ highlight: activeName === item.key }"
					>
						{{ $t(item.val) }}
					</li>
				</ul>
				<div>
					<el-form ref="form" :rules="rules" :model="formData">
						<el-form-item prop="account" class="mt48">
							<!-- <el-input
								:placeholder="activeName === 'password' ? '请输入手机号码/邮箱/账号' : '请输入手机号码/邮箱'"
								v-model="formData.account"
								@keyup.enter.native="onSubmit"
								clearable
							>
							</el-input> -->
							<el-input
								:placeholder="
									activeName === 'password'
										? $t('MAIN_WEB_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND_EMAIL', {
												text: $t('MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND', { text: '请输入手机号码/邮箱' }),
										  })
										: $t('MAIN_WEB_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND_EMAIL', {
												text: $t('MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND', { text: '请输入手机号码/邮箱' }),
										  })
								"
								v-model="formData.account"
								@keyup.enter.native="onSubmit"
								clearable
							>
							</el-input>
						</el-form-item>
						<el-form-item prop="password" v-if="activeName === 'password'" ref="password" class="mt32">
							<el-input
								:type="passw"
								:placeholder="$t('MAIN_WEB_ENTER_A_PASSWORD', { text: '请输入密码' })"
								v-model="formData.password"
								@keyup.enter.native="onSubmit"
								key="password"
								clearable
							>
							</el-input>
						</el-form-item>
						<el-form-item v-else prop="authCode" ref="authCode" class="mt32 input_auth_btn">
							<el-input
								:placeholder="$t('MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE', { text: '请输入验证码' })"
								v-model="formData.authCode"
								@keyup.enter.native="onSubmit"
							>
							</el-input>
							<div class="count_down" @click="postAccountGetAuthCode" :class="{ active_btn: 0 < Countdown.time }">
								{{ 0 >= Countdown.time ? this.$t('MAIN_WEB_OBTAIN_VERIFICATION_CODE', { text: '获取验证码' }) : countTimer }}
							</div>
						</el-form-item>
            <div class="bottom-btn">
                <div class="slhSignIn forget" v-if="theme === 'shanglianhui'">
                    <router-link :to="{ path: '/entrance/slhSignIn' }">{{$t('MAIN_WEB_REGISTER_NOW',{text:'立即注册'})}}</router-link>
                </div>
                <div v-show="activeName === 'password'" class="forget">
                  <router-link :to="{ name: 'forget', query: { account: formData.account } }">{{$t('MAIN_WEB_FORGOT_PASSWORD',{text:'忘记密码'})}}</router-link>
                </div>
            </div>


						<el-form-item  class="mt76">
							<el-button type="primary" class="login-btn" @click="onSubmit">{{$t('MAIN_WEB_LOGIN',{text:'登录'})}}</el-button>
						</el-form-item>
					</el-form>
				</div>
				<!-- <div> -->
				<!-- <span class="res">
                    $t('MAIN_WEB_NO_ACCOUNT_YET',{text:'还没账号？'})
                    <router-link  :to="{ name: 'register' }">$t('MAIN_WEB_REGISTER_NOW',{text:'立即注册'})</router-link>
                </span> -->
				<!-- </div> -->
			</div>
		</div>
		<organ v-if="isShowOrgan" @changeShowOrgan="handleChangeShow" :solutionName="solutionName"></organ>
	</div>
</template>

<script>
import { mapState } from 'vuex'
import organ from './organ.vue'
import conf from '../../config/url.js'
import api from '../../api'
import themeStyle from '@wd/lowcode-pc/plugin/theme/index'
import cssVars from 'css-vars-ponyfill'
// import getLanguageData from '../../locale/locale'
// import { phoneMmailAccountValidator } from './../../util/validate'
import MD5 from 'js-md5'
const isPhone = /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/
const isMail = /\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*/
export default {
	name: 'login',
	components: {
		organ
	},
	data() {
		const accountValidator = (rule, value, callback) => {
			if (!value) {
				if (this.activeName === 'password') {
					callback(new Error(this.$t('MAIN_WEB_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND_EMAIL', { text: '请输入手机号码/邮箱/账号' })))
				} else {
					callback(new Error(this.$t('MAIN_WEB_PLEASE_ENTER_YOUR_MOBILE_PHONE_NUMBER_AND', { text: '请输入手机号码/邮箱' })))
				}
			} else {
				callback()
			}
		}
		return {
			isI18nFlag: false, //判断是否是国际化项目
			internationalName: 'English',
			internationalKey: 'en-US',
			setUpLanguageTimeout: null,
			setUpLanguageShow: false,
			isShowOrgan: false,
			institutionsList: [],
			islogin: true,
			Countdown: {
				time: 0,
			},
			activeName: 'password',
			passw: 'password',
			tabsList: [
				{ key: 'password', val: 'MAIN_WEB_PASSWORD_LOGON' },
				{ key: 'Verification', val: 'MAIN_WEB_VERIFICATION_CODE_LOGIN' },
			],
			// rules: {

			// },

			formData: {
				account: '',
				password: '',
				authCode: '',
				adminFlag: 1,
			},
			loginImg: '',
			defaultLogo: require('../../assets/images/logo@2x.png'),
			defaultImg: require('../../assets/images/pexels.png'),
			theme:"",
            loginBackgroundLogo: '',
			branchIndustry:'',
			solutionName:''//
		}
	},
	computed: {
		...mapState(['theme']),
		countTimer() {
			return this.Countdown.time + 's' + this.$t('MAIN_WEB_THEN_RETRIEVE', { text: '后重新获取' })
		},
		rules() {
			return {
				account: [
					{
						validator: this.accountValidator,
						trigger: 'blur',
					},
				],
				password: [{ required: true, message: this.$t('MAIN_WEB_ENTER_A_PASSWORD', { text: '请输入密码' }), trigger: 'blur' }],
				authCode: [
					{ required: true, message: this.$t('MAIN_WEB_PLEASE_ENTER_A_VERIFICATION_CODE', { text: '请输入验证码' }), trigger: 'blur' },
					{ min: 6, max: 6, message: this.$t('MAIN_WEB_PLEASE_ENTER_A_SIXDIGIT_VERIFICATION_CODE', { text: '请输入六位验证码' }), trigger: 'blur' },
				],
			}
		},
		international() {
			return [
				{ key: 'zh-CN', val: '中文' }, //中文
				{ key: 'en-US', val: 'English' }, //英语
				// {key:"fr-FR",val: 'MAIN_WEB_HEADER_FR'}//法语
			]
		},
	},
	created() {
        this.formData.account = this.$route.query.account || ''
        this.getNewConfiguration()
		this.getConfiguration()
		if (localStorage.getItem('current_language')) {
			let innertational = this.international.filter((item) => item.key == localStorage.getItem('current_language'))
			if (innertational && innertational.length > 0) {
				this.internationalName = innertational[0].val
				this.internationalKey = innertational[0].key
			}
		}
	},
	mounted() {
        this.$store.state.nav = []
        // var configurationConfig = JSON.parse(localStorage.getItem("configurationConfig"));

		// if (location.href.indexOf("#reloaded") == -1) {
		//     location.href = location.href + "#reloaded";
		//     location.reload();
		// }
		// localStorage.clear()
		// sessionStorage.clear()
	},
	methods: {
        getNewConfiguration() {
            // this.$api.configuration.getNewConfiguration(conf.confUrl).then((res) => {
            //     if (res.success && res.data) {
            //         this.branchIndustry = res.data.branchIndustry
            //     }
            // })
            let branchIndustry = localStorage.getItem('branchIndustry')||sessionStorage.getItem('branchIndustry')
            this.branchIndustry =  branchIndustry
        },
        // getConfiguration() {
        //     let mainTheme = sessionStorage.getItem('mainTheme')
        //     if (mainTheme) {
        //         this.setTheme(mainTheme)
        //     }
        //     // let frontendConfig = res.data.frontendConfig
        //     let  frontendConfig = sessionStorage.getItem('frontendConfig') && JSON.parse(sessionStorage.getItem('frontendConfig'))||[];


        //     frontendConfig.map((item) => {
        //         if (item.key === 'theme') {
        //             if (!mainTheme) {
        //                 this.setTheme(item.value)
        //                 sessionStorage.setItem('mainTheme', item.value)
        //             }
        //         }
        //         if (item.key === 'custom_login_background_img' && item.value) {
        //             localStorage.setItem('loginBackgroundImg', item.value)
        //             // this.$store.commit('setLoginBackgroundImg', item.value)
        //         }
        //         if (item.key === 'custom_login_img' && item.value) {
        //             localStorage.setItem('loginImg', item.value)
        //             // this.$store.commit('setLoginImg', item.value)
        //         }
        //         if (item.key == 'is_i18n') {
        //             localStorage.setItem('is_i18n', item.value)
        //             // 如果是国际化显示切换语言
        //             if (item.value == 'true') {
        //                 this.isI18nFlag = true
        //             } else {
        //                 this.isI18nFlag = false
        //             }
        //         }
        //     })
        //     this.loginImg = localStorage.getItem('loginImg') || this.defaultImg
        //     // this.setTheme('init');

        //     let websiteLogo = localStorage.getItem('websiteLogo') || sessionStorage.getItem('websiteLogo');
        //     if (websiteLogo) {
        //         this.$store.commit('setLogo', websiteLogo)
        //         localStorage.setItem('websiteLogo', websiteLogo)
        //     }
        //     /** 培训任务数据统计用到 */
        //     let theme = localStorage.getItem('theme') || sessionStorage.getItem('theme');

        //     this.$store.commit('setTheme', theme)
        //     this.theme = theme
        //     localStorage.setItem('theme', theme)
        //     let  domain = sessionStorage.getItem('domain') || localStorage.getItem('domain');

        //     localStorage.setItem('domain', JSON.stringify(domain) ? JSON.stringify(domain) : '')
        //     localStorage.setItem(
        //         'configurationConfig',
        //         res.data && JSON.stringify(frontendConfig) ? JSON.stringify(frontendConfig) : ''
        //     )
        //     const a = frontendConfig((item) => item.key === 'is_open_platform_up_commodity')
        //     localStorage.setItem('isOpenToPlateform', a.value)
        //     /**  * cms 配置网页标题 */

        //     let  pageTitle = sessionStorage.getItem('pageTitle') || localStorage.getItem('pageTitle');

        //     if (pageTitle) {
        //         localStorage.setItem('pageTitle', pageTitle)
        //     }
        //     document.title =
        //         (pageTitle) ||
        //         this.$t('MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION', { text: '共享教育资源 传承人类文明' })

        // },

        getConfiguration() {
		
        	let mainTheme = sessionStorage.getItem('mainTheme')
			if (mainTheme) {
				this.setTheme(mainTheme)
			}
			this.$api.configuration
				.getConfiguration(conf.confUrl)
				.then((res) => {
					this.solutionName = res.data.solutionName;
					let frontendConfig = res.data.frontendConfig
					frontendConfig.map((item) => {
						if (item.key === 'theme') {
							if (!mainTheme) {
								this.setTheme(item.value)
								sessionStorage.setItem('mainTheme', item.value)
							}
						}
						if (item.key === 'custom_login_background_img' && item.value) {
							localStorage.setItem('loginBackgroundImg', item.value)
							// this.$store.commit('setLoginBackgroundImg', item.value)
						}
						if (item.key === 'custom_login_img' && item.value) {
							localStorage.setItem('loginImg', item.value)
							// this.$store.commit('setLoginImg', item.value)
						}
						if (item.key === 'login_background_logo') {
							this.loginBackgroundLogo = item.value || this.defaultLogo
						}
						if (item.key == 'is_i18n') {
							localStorage.setItem('is_i18n', item.value)
							// 如果是国际化显示切换语言
							if (item.value == 'true') {
								this.isI18nFlag = true
							} else {
								this.isI18nFlag = false
							}
						}
					})
					this.loginImg = localStorage.getItem('loginImg') || this.defaultImg
					// this.setTheme('init');
					if (res.data && res.data.websiteLogo) {
						this.$store.commit('setLogo', res.data.websiteLogo)
						localStorage.setItem('websiteLogo', res.data.websiteLogo)
					}
					/** 培训任务数据统计用到 */
					this.$store.commit('setTheme', res.data.theme)
          			this.theme = res.data.theme || ''
					localStorage.setItem('theme', res.data && res.data.theme)
        
					localStorage.setItem('domain', res.data && JSON.stringify(res.data.domain) ? JSON.stringify(res.data.domain) : '')
					localStorage.setItem(
						'configurationConfig',
						res.data && JSON.stringify(res.data.frontendConfig) ? JSON.stringify(res.data.frontendConfig) : ''
					)
					const a = res.data.frontendConfig.find((item) => item.key === 'is_open_platform_up_commodity')
					localStorage.setItem('isOpenToPlateform', a.value)
					/**  * cms 配置网页标题 */
					if (res.data.pageTitle) {
						localStorage.setItem('pageTitle', res.data.pageTitle)
					}
					document.title =
						(res.data && res.data.pageTitle) ||
						this.$t('MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION', { text: '共享教育资源 传承人类文明' })
				})
				.catch((err) => {
					console.log(err)
					document.title = this.$t('MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION', { text: '共享教育资源 传承人类文明' })
				})
		},
		async selectChange(key, value) {
			console.log(key, value, 'key', 'value', this.$t(value))
			localStorage.setItem('current_language', key)
			this.$i18n.locale = key
			await this.documenetTitle()
			this.internationalKey = key
			this.internationalName = value
			this.setUpLanguageTimeout = setTimeout(() => {
				this.setUpLanguageShow = false
			}, 100)
		},
		documenetTitle() {
			document.title =
				localStorage.getItem('pageTitle') ||
				this.$t('MAIN_WEB_SHARING_EDUCATIONAL_RESOURCES_TO_INHERIT_HUMAN_CIVILIZATION', { text: '共享教育资源 传承人类文明' })
		},
		// 切换语言
		setUpLanguageEnter() {
			clearTimeout(this.setUpLanguageTimeout)
			this.setUpLanguageShow = true
		},
		setUpLanguageLeave() {
			this.setUpLanguageTimeout = setTimeout(() => {
				this.setUpLanguageShow = false
			}, 300)
		},
		setTheme(name) {
			const initTheme = (name) => {
				document.documentElement.setAttribute('data-theme', name)
				cssVars({
					silent: true,
					watch: true, // 当添加，删除或修改其<link>或<style>元素的禁用或href属性时，ponyfill将自行调用
					variables: themeStyle[name], // variables 自定义属性名/值对的集合
					onlyLegacy: false, // false  默认将css变量编译为浏览器识别的css样式  true 当浏览器不支持css变量的时候将css变量编译为识别的css
				})
			}
			initTheme(name)
		},
		handleChangeShow(val) {
			this.isShowOrgan = val
		},
		showPassw() {
			if (this.passw === 'password') {
				this.passw = 'text'
			} else {
				this.passw = 'password'
			}
		},
		passwordShow() {
			console.debug('passwordShow')
		},
		// disabled () {
		//   if (this.formData.account && (this.formData.password || this.formData.authCode)) {
		//     return false
		//   } else {
		//     return true
		//   }
		// },
		async onSubmit() {
			// localStorage.clear()
			// sessionStorage.clear()
			this.$refs.form.validate((valid) => {
				if (valid) {
					this.activeName === 'password' && this.postAccountLogin()
					this.activeName === 'Verification' && this.postAccountLoginByAuthCode()
				} else {
					return false
				}
			})
			localStorage.setItem('is_i18n', this.isI18nFlag)
			localStorage.setItem('timezone',localStorage.getItem('timezone'))
			if (this.isI18nFlag) {
				localStorage.setItem('current_language', localStorage.getItem('current_language'))
			} else {
				// 不是国际化
				localStorage.setItem('current_language', 'zh-CN')
			}
		},
		async postAccountLogin() {
			const password = MD5(this.formData.password)
			const data = {
				account: this.formData.account,
				password,
				adminFlag: this.formData.adminFlag,
			}
			return this.$api.operate.postAccountLogin({ data }).then(async (res) => {
				if (res.code != 0) {
					console.debug(this.$t('MAIN_WEB_PLEASE_CONFIRM_WHETHER_IT_IS_REGISTERED', { text: '请确认是否已注册' }))
					return false
				}
				localStorage.setItem('token', res.data)
				sessionStorage.setItem('token', res.data)
				this.isShowOrgan = true
				// 判断是否长时间未修改密码
				this.$api.operate.checkPasswordTime()
			})
		},
		postAccountLoginByAuthCode: async function () {
			const data = {
				account: this.formData.account,
				authCode: this.formData.authCode,
				adminFlag: this.formData.adminFlag,
			}
			return this.$api.operate.postAccountLoginByAuthCode({ data }).then(async (res) => {
				if (res.code) {
					console.debug(this.$t('MAIN_WEB_PLEASE_CONFIRM_WHETHER_IT_IS_REGISTERED', { text: '请确认是否已注册' }))
					return false
				}
				localStorage.setItem('token', res.data)
				sessionStorage.setItem('token', res.data)
				this.isShowOrgan = true
			})
		},
		postAccountGetAuthCode() {
			const data = {
				phone: this.formData.account,
				type: 1,
				adminFlag: 1,
			}
			if (isPhone.test(data.phone) || isMail.test(data.phone)) {
				if (this.Countdown.time > 0) return
				this.Countdown.time = 60
				this.setCountdown()
				this.$api.operate.postAccountGetAuthCode({ data })
			}
		},
		setCountdown() {
			let Countdown = null
			Countdown = setInterval(() => {
				this.Countdown.time--
				if (this.Countdown.time <= 0) {
					clearInterval(Countdown)
				}
			}, 1000)
		},
		setActiveName(val) {
			this.activeName = val
			if (this.activeName === 'password') {
				this.$refs.form.clearValidate()
			} else {
				this.$refs.form.clearValidate()
			}
		},
	},
}
</script>

<!--<style lang="stylus" src="./index.styl" scoped>-->
<!--</style>-->
<!--<style lang="stylus" scoped>-->

<!--//@import 'index.styl';-->
<!--//.login_wrap-->
<!--//	/deep/ .el-form-item__error-->
<!--//		left 0-->
<!--//		padding-top 8px-->
<!--//-->
<!--//	.tabs li-->
<!--//		cursor: pointer-->
<!--//-->
<!--//	.password-->
<!--//		margin 12px-->
<!--//		font-size 16px-->
<!--//-->
<!--//	/deep/ .el-input__inner-->
<!--//	  //-webkit-box-shadow 0 0 0 1000px #ffffff inset-->
<!--//		//box-shadow 0 0 0 1000px #ffffff inset-->
<!--//	/deep/ .el-input-group__append-->
<!--//		border 0;-->
<!--//.login-international{-->
<!--//	cursor default-->
<!--//	display: flex;-->
<!--//	align-items: center;-->
<!--//	border-radius 4px-->
<!--//	position absolute;-->
<!--//	top 16px;-->
<!--//	right 0px;-->
<!--//	width 120px;-->
<!--//	height 40px;-->
<!--//	.international-img{-->
<!--//		width 14px-->
<!--//		height 14px-->
<!--//		margin-left: 6px;-->
<!--//	}-->
<!--//	img {-->
<!--//		width 24px-->
<!--//		height 16px-->
<!--//		margin-right 8px-->
<!--//	}-->
<!--//	span{-->
<!--//		color #666666;-->
<!--//		max-width 120px-->
<!--//		overflow hidden-->
<!--//		text-overflow ellipsis-->
<!--//		white-space nowrap-->
<!--//	}-->
<!--//	i{-->
<!--//		color #ffffff-->
<!--//		margin-left 12px-->
<!--//	}-->
<!--//	ul{-->
<!--//		box-shadow 0px 0px 8px 2px rgba(3, 3, 3, 0.1)-->
<!--//		position absolute-->
<!--//		top 40px-->
<!--//		right 16px-->
<!--//		z-index 9-->
<!--//		display inline-block-->
<!--//		padding 4px 0-->
<!--//		border-radius 4px-->
<!--//		background-color #fff-->
<!--//		li{-->
<!--//			text-align left-->
<!--//			width: 87px;-->
<!--//			padding 0 16px-->
<!--//			height 32px-->
<!--//			font-size 14px-->
<!--//			line-height 32px-->
<!--//			color #333333-->
<!--//			overflow hidden-->
<!--//			text-overflow ellipsis-->
<!--//			white-space nowrap-->
<!--//		}-->
<!--//	}-->
<!--//}-->
<!--//-->

<!--</style>-->
